import type { StepType } from "@reactour/tour";

export const tourSteps: StepType[] = [
	{
		selector: "[data-tour-id='title']",
		content:
			"Esta es la pantalla de imputación. Permite seleccionar un rango de fechas y añadir los valores de consumo de las referencias configuradas.",
	},
	{
		selector: "[data-tour-id='date-range']",
		content:
			"Empieza seleccionando el rango de fechas para el que se corresponde esta imputación.",
	},
	{
		selector: "[data-tour-id='header-factor']",
		content:
			"El factor de emisión es el valor que se utiliza para calcular la huella de carbono de cada referencia.",
	},
	{
		selector: "[data-tour-id='header-referencia']",
		content:
			"La referencia es el nombre del concepto que se está configurando. Estas deben estar previamente configuradas en la sección de configuración de referencias.",
	},
	{
		selector: "[data-tour-id='header-valor']",
		content:
			"El valor hace referencia al consumo de la referencia en el rango de fechas seleccionado. Por ejemplo, si se está imputando gasolina, el valor sería la cantidad de litros consumidos en las fechas seleccionadas.",
	},
	{
		selector: "[data-tour-id='header-co2']",
		content:
			"El CO2 es un valor informativo que se calcula automáticamente en base al valor introducido y el factor de emisión de la referencia. En caso de que este no parezca correcto, se debe revisar la configuración de la referencia.",
	},
	{
		selector: "[data-tour-id='submit-button']",
		content:
			"El botón de guardar salva los cambios realizados en la imputación.",
	},
];
